import api from '@pray/shared/utils/api';

import type { SmsConfig } from './types';

type DeleteSmsNumberProps = {
  artistId: string;
};

export async function deleteSmsNumber({ artistId }: DeleteSmsNumberProps) {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/sms-config/delete`;

  const response = await api.executePostRequest<{ data: SmsConfig }>(url);

  return response.data;
}
